import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js"
import "chartjs-plugin-datalabels"
import { useLocale } from "next-intl"

import { Doughnut } from "react-chartjs-2"
import { useIsDesktop } from "ui"

ChartJS.register(ArcElement, Tooltip, Legend)

type Props = {
  stockHolderData: any
}

export function PieChart({ stockHolderData }: Props) {
  const labels = stockHolderData.stockHolders
    ?.sort((a: any, b: any) => b.capital - a.capital)
    .map((item: { shareHolderName: any }) => item.shareHolderName)
  const values = stockHolderData.stockHolders
    ?.sort((a: any, b: any) => b.capital - a.capital)
    .map((item: { capital: any }) => item.capital)

  const isDesktop = useIsDesktop()
  const locale = useLocale()

  const data = {
    datasets: [
      {
        data: values,
        labels: labels,
        backgroundColor: [
          "#0E4D81",
          "#1679CA",
          "#1988E2",
          "#C8E8FF",
          "#B6D9F7",
          "#238EE7",
          "#5AAFED",
          "#B6D9F7",
        ],

        borderColor: "white",
        borderWidth: 6,
      },
    ],
  }

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,

    elements: {
      arc: {
        borderWidth: 0,
      },
    },
    cutout: "70%",
    hover: {
      mode: null, // Disable hover effect on entire dataset
    },
    layout: {
      padding: -15,
    },
    plugins: {
      tooltip: {
        enabled: false, // Disable the default tooltip

        external: function (context: {
          tooltip: any
          chart: { canvas: { getBoundingClientRect: () => any } }
        }) {
          let tooltipEl = document.getElementById("chartjs-tooltip")

          if (!tooltipEl) {
            tooltipEl = document.createElement("div")
            tooltipEl.id = "chartjs-tooltip"
            tooltipEl.style.width = "164px"
            tooltipEl.style.height = "64px"
            tooltipEl.style.backgroundColor = "white"
            tooltipEl.style.padding = "10px"
            tooltipEl.style.height = "auto"
            tooltipEl.style.borderRadius = "5px"
            tooltipEl.innerHTML = "<div id='tooltip-content'></div>"
            tooltipEl.style.boxShadow = "2px 2px 6px rgba(0, 0, 0, 0.2)"
            document.body.appendChild(tooltipEl)
          }

          const tooltipModel = context.tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = "0"
            return
          }

          tooltipEl.classList.remove("above", "below", "no-transform")
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign)
          } else {
            tooltipEl.classList.add("no-transform")
          }

          const body = `${tooltipModel.body[0]?.lines[0]}%` || ""
          const labelIndex = tooltipModel.dataPoints[0]?.dataIndex
          const labelName = labels[labelIndex] || "" // Get label name

          const innerHtml = `
          <div style="width: 100%; height: 100%; display: flex; flex-direction: column; align-items: start; justify-content: center;">
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <div style="background-color: ${
                tooltipModel.labelColors[0]?.backgroundColor || "transparent"
              }; width: 8px; height: 8px; border-radius: 50%; margin-left: ${
            locale === "he" ? "6px" : "0px"
          }; margin-right: ${locale === "he" ? "0px" : "10px"}"></div>
              <div style=" font-weight: bold; width: calc(100% - 16px)">${labelName}</div>
            </div>
            <div style="display: flex; align-items: center; ">
              <div style="width: 8px; height: 8px; margin-left: ${
                locale === "he" ? "6px" : "0px"
              }; margin-right: ${locale === "he" ? "0px" : "10px"}"></div>
              <div>${body}</div>
            </div>
          </div>
          `

          tooltipEl.innerHTML = innerHtml

          const position = context.chart.canvas.getBoundingClientRect()
          tooltipEl.style.opacity = "1"
          tooltipEl.style.position = "absolute"
          tooltipEl.style.zIndex = "1"
          if (isDesktop)
            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + "px"
          else
            tooltipEl.style.left =
              position.left + window.pageXOffset + tooltipModel.caretX / 2 + "px"
          tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + "px"
          tooltipEl.style.pointerEvents = "none"
        },
      },
    },
  } as any

  return <Doughnut data={data} options={chartOptions} />
}
